import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false,
})
export class MaterialFileUploadComponent implements OnInit {
    @Input() placeholder = 'Attach files';
    @Input() multipleFilesAccepted = false;
    @Input() required = false;

    @Output() uploadFiles: EventEmitter<FileList> = new EventEmitter<FileList>();

    @ViewChild('inputForm') readonly inputForm!: any;

    private fileLabel = '';
    public files!: FileList;
    public control: FormControl = new FormControl();
    constructor() {}

    onSelectFiles(event: any): void {
        this.files = event.target.files ?? null;
        this.fileLabel = this.getFilesLabel();
        if (this.required) {
            this.control.patchValue(this.fileLabel);
        }
        this.uploadFiles.next(this.files);
    }

    getFilesName(): string {
        return this.fileLabel;
    }

    getFilesLabel(): string {
        if (!this.files) {
            return 'No file selected';
        }

        const filesSelected = this.files.length;
        switch (filesSelected) {
            case 0:
                return 'No file selected';
            case 1:
                return this.files[0].name;
            default:
                return `${this.files.length} files selected`;
        }
    }

    resetForm = (): void => {
        this.inputForm.nativeElement.reset();
        if (this.required) {
            this.control.patchValue('');
        }
    };

    ngOnInit() {
        if (this.required) {
            this.control.addValidators(Validators.required);
        }
    }
}
